function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import { getLoginInfo } from '@/libs/public';
import { getLeafMenuPaths } from '@/utils/system';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

// /settle 是入驻申请页，访问者还没有账号，不能被登录态拦截
var whiteList = ['/login', '/auth-redirect', '/settle']; // no redirect whitelist
// 无需权限校验的白名单路由
var publicRoutes = ['/login', '/auth-redirect', '/settle', '/401', '/404', '/', '/redirect'];
// 账户设置是所有已登录商户管理员的固定入口，不依赖侧边栏菜单。
var authenticatedRoutes = ['/maintain/user'];
function to_activeMenu(route) {
  return route.meta && route.meta.activeMenu;
}

/** 检查目标路由是否在用户菜单权限内 */
function hasRoutePermission(route) {
  // 公共路由直接放行
  if (publicRoutes.some(function (p) {
    return route.path === p || route.path.startsWith('/redirect/');
  })) {
    return true;
  }
  if (authenticatedRoutes.some(function (p) {
    return route.path === p || route.path.startsWith(p + '/');
  })) {
    return true;
  }
  // 从 store 或 localStorage 获取用户菜单列表
  var menuList = store.state.user.menuList || [];
  if (!menuList.length) return false;
  // 首页虽然标为 M 类型，仍是后端明确授权的实际页面。
  if (route.path === '/dashboard' && menuList.some(function (item) {
    return item.path === '/dashboard';
  })) return true;
  // 只有菜单叶子节点代表实际可访问页面；父级分组不能放行全部子页面。
  var accessiblePaths = getLeafMenuPaths(menuList);
  if (!accessiblePaths.length) return false;
  // 新增 / 编辑这类隐藏子页面（如添加拼团、参加秒杀）没有自己的菜单，
  // 靠 meta.activeMenu 挂在所属列表页下：列表页有权限，子页面就放行
  var activeMenus = [to_activeMenu(route)].concat(route.matched.map(function (m) {
    return m.meta && m.meta.activeMenu;
  })).filter(Boolean);
  if (activeMenus.some(function (am) {
    return accessiblePaths.includes(am);
  })) return true;
  // 检查目标路由是否匹配任一菜单叶子路径（含动态路由如 /product/list/123）
  return accessiblePaths.some(function (menuPath) {
    if (route.path === menuPath) return true;
    if (route.path.startsWith(menuPath + '/')) return true;
    // 对 matched 中的记录也做前缀匹配（处理嵌套路由带参数的情况）
    return route.matched.some(function (m) {
      return m.path === menuPath || m.path.startsWith(menuPath + '/');
    });
  });
}
router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, from, next) {
    var _to$query, token, account, isSms, leftSquareLogo, leftTopLogo, realName, hasToken, menuListEmpty, hasRoles, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          // start progress bar
          NProgress.start();
          // set page title
          document.title = getPageTitle(to.meta.title);
          if (!to.query.token) {
            _context.n = 3;
            break;
          }
          _to$query = to.query, token = _to$query.token, account = _to$query.account, isSms = _to$query.isSms, leftSquareLogo = _to$query.leftSquareLogo, leftTopLogo = _to$query.leftTopLogo, realName = _to$query.realName;
          getLoginInfo(to.query);
          _context.n = 1;
          return store.dispatch('user/getMenus');
        case 1:
          _context.n = 2;
          return store.dispatch('user/getInfo');
        case 2:
          next();
          NProgress.done();
          _context.n = 14;
          break;
        case 3:
          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.n = 13;
            break;
          }
          if (!(to.path === '/login')) {
            _context.n = 4;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          NProgress.done();
          _context.n = 12;
          break;
        case 4:
          // 如果菜单列表为空，重新加载菜单
          menuListEmpty = !store.state.user.menuList.length;
          if (!(menuListEmpty && hasToken)) {
            _context.n = 5;
            break;
          }
          _context.n = 5;
          return store.dispatch('user/getMenus');
        case 5:
          // 如果角色信息为空，加载用户信息
          hasRoles = store.getters.roles && store.getters.roles.length > 0;
          if (hasRoles) {
            _context.n = 10;
            break;
          }
          _context.p = 6;
          if (!hasToken) {
            _context.n = 7;
            break;
          }
          _context.n = 7;
          return store.dispatch('user/getInfo');
        case 7:
          _context.n = 10;
          break;
        case 8:
          _context.p = 8;
          _t = _context.v;
          _context.n = 9;
          return store.dispatch('user/resetToken');
        case 9:
          Message.error(_t || 'Has Error');
          next("/login?redirect=".concat(to.path));
          NProgress.done();
          return _context.a(2);
        case 10:
          if (hasRoutePermission(to)) {
            _context.n = 11;
            break;
          }
          next({
            path: '/401',
            replace: true
          });
          NProgress.done();
          return _context.a(2);
        case 11:
          next();
        case 12:
          _context.n = 14;
          break;
        case 13:
          /* has no token*/
          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            NProgress.done();
          }
        case 14:
          return _context.a(2);
      }
    }, _callee, null, [[6, 8]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});